<ion-content
  scrollbar
  class="space-reservations__container ion-content-padding-top-0"
>
  <ng-container *appHasRole="[addReservationRole]">
    <ion-fab
      *ngIf="p.renderMobile"
      vertical="bottom"
      horizontal="end"
      slot="fixed"
    >
      <ion-fab-button (click)="onReroute()">
        <ion-icon name="add"></ion-icon>
      </ion-fab-button>
    </ion-fab>
  </ng-container>

  <ion-grid>
    <app-list-header 
      (toggleFilter)="onToggleFilter()" 
      mobileWidth="600"
      [absoluteFilterButton]="true"  
    >
      <ng-container top>
        <div
          class="display-flex ion-align-items-center ion-justify-content-between"
          *ngIf="!p.renderMobile"
        >
          <ion-button
            class="sb-add-button menu-header-button"
            size="medium"
            (click)="onReroute()"
            *appHasRole="[addReservationRole]"
          >
            <ion-icon name="add" slot="start"></ion-icon>
            <ion-label>{{ "SPACE.ADD_RESERVATION" | translate }}</ion-label>
          </ion-button>
          <div class="display-flex ion-align-items-center">
            <ng-container *ngIf="!showAllReservations; else search">
              <ion-label class="ion-text-end">
                {{ "SPACE.SHOW_ALL_RESERVATIONS" | translate }}
              </ion-label>
              <ion-toggle
                (ionChange)="onToggleReservationList()"
                [checked]="filterDetails.showPastReservations"
              ></ion-toggle>
            </ng-container>
          </div>
        </div>
        <div
          class="space-reservations__mobile-searchbar-container"
          *ngIf="p.renderMobile"
        >
          <div class="space-reservations__mobile-searchbar-inner-container">
            <ng-container *ngTemplateOutlet="search"></ng-container>
          </div>
        </div>
      </ng-container>
      <ng-container bottom>
        <app-space-filter
          *ngIf="showAllReservations"
          [events]="eventsSubject.asObservable()"
          mobileHeader="SPACE.ALL_RESERVATIONS"
          [subscribedFilter]="filterDetailsSubject"
          [showCalendarFilter]="true"
          [showToggleButton]="true"
          [spaceType]="spaceType"
          [showAllReservationsToggleButtonModal]="false"
        ></app-space-filter>
        <div
          class="display-flex ion-justify-content-between"
          *ngIf="!showAllReservations"
        >
          <app-space-filter
            [events]="eventsSubject.asObservable()"
            mobileHeader="SPACE.MY_RESERVATIONS"
            [spaceType]="spaceType"
            [subscribedFilter]="filterDetailsSubject"
            [showAllReservationsToggleButtonModal]="true"
          ></app-space-filter>
          <ng-container *ngIf="!p.renderMobile">
            <ng-container *ngTemplateOutlet="search"></ng-container>
          </ng-container>
        </div>
      </ng-container>
    </app-list-header>

    <app-pagination-client-side
      *ngIf="!filterDetails.showSpacesWithCharts && !hideEmptyAssignments"
      [ngClass]="{ 'height-0': showLoaderAssignments }"
      [columns]="columnsDefinitionMyAssignments"
      [options]="optionsMyAssignments"
      [componentRef]="componentRefUserAssignment"
      (rowsLoaderReady)="rowsLoaderServiceReady($event)"
      (actionRequest)="updateAssignments($event)"
    >
    </app-pagination-client-side>
    <app-pagination-client-side
      *ngIf="
        !filterDetails.showSpacesWithCharts &&
        (!hideEmptyBookings || hideEmptyAssignments)
      "
      [ngClass]="{ 'height-0': showLoaderReservations }"
      [options]="optionsMyReservations"
      [columns]="columnsDefinitionMyReservations"
      [componentRef]="componentRef"
      (rowsLoaderReady)="rowsLoaderBookingServiceReady($event)"
      (actionRequest)="updateReservations($event)"
    >
    </app-pagination-client-side>

    <!-- lista miejsc parkingowych z wykresem zajętości -->
    <app-pagination-client-side
      *ngIf="filterDetails.showSpacesWithCharts"
      [ngClass]="{ 'height-0': showLoaderReservations }"
      [options]="optionsParkingPlace"
      [columns]="columnsDefinitionParkingPlace"
      [componentRef]="componentRefParking"
      (rowsLoaderReady)="rowsLoaderParkingPlaceServiceReady($event)"
    >
    </app-pagination-client-side>
  </ion-grid>
</ion-content>

<div class="spin--full" *ngIf="showLoaderAssignments && !showAllReservations">
  <app-loading-sti></app-loading-sti>
</div>

<div class="spin--full" *ngIf="showLoaderReservations">
  <app-loading-sti></app-loading-sti>
</div>

<!-- Template dla wyszukiwania. -->
<ng-template #search>
  <app-search-bar
    (searchEvent)="
      searchbarValue = $event;
      filterDetails.showSpacesWithCharts
        ? searchInSpaces()
        : searchInReservations();
      searchInAssignments()
    "
  ></app-search-bar>
</ng-template>
